// chat/RenderFollowupQuestions.tsx

import { useCallback, useRef } from "react";

export type followUpQuestionProps = {
  isLoading?: boolean;
  followupQuestions: string[];
  onFollowupQuestionClicked?: (question: string) => void;
  isDisabled?: boolean; // <-- Add this prop
};

const RenderFollowupQuestions = ({
  isLoading,
  followupQuestions,
  onFollowupQuestionClicked,
  isDisabled, // <-- Destructure the prop
}: followUpQuestionProps) => {
  const timeoutId = useRef<any>(null);

  const debouncedOnClick = useCallback(
    (item: any) => {
      // You might also want to check isDisabled here to prevent the debounce from even firing
      if (isDisabled) return;

      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }

      timeoutId.current = setTimeout(() => {
        if (onFollowupQuestionClicked) {
          onFollowupQuestionClicked(item);
        }
      }, 300); // 300ms delay
    },
    [onFollowupQuestionClicked, isDisabled] // <-- Add isDisabled to dependencies
  );

  return (
    <div className="pt-2">
      {Array.isArray(followupQuestions) ? (
        <ol className=" pl-6">
          {followupQuestions.length ? (
            <div className=" font-title">Follow up Questions</div>
          ) : (
            ""
          )}
          {followupQuestions.map((item, index) => (
            <div className="" key={index}>
              <button
                className="cursor-pointer link_text_color hover:text-white mt-1 text-left"
                onClick={() => debouncedOnClick(item)}
                disabled={isDisabled || isLoading} // <-- Use isDisabled here to disable the button
                // Also adding isLoading here, as it's a direct indicator for this specific card
                style={{ cursor: (isDisabled || isLoading) ? "not-allowed" : "pointer" }} // Optional: change cursor
              >
                <div className="p-2 card_bg_color rounded-md hover:bg-slate-600 ">
                  <span>{item.toString().replace(/_/g, " ")}</span>
                </div>
              </button>
            </div>
          ))}
        </ol>
      ) : typeof followupQuestions === "string" ? (
        <p>{followupQuestions}</p>
      ) : (
        followupQuestions && (
          <a href={followupQuestions} target="_blank" rel="noopener noreferrer">
            {followupQuestions}
          </a>
        )
      )}
    </div>
  );
};

export default RenderFollowupQuestions;